// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__14tZt","header":"ReportDetails_header__2yFk-","title":"ReportDetails_title__1if3D","left":"ReportDetails_left__37oqt"};